import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles} from '@material-ui/core'
import {css} from 'src/conf/style'
import RcPage from '../RcPage/RcPage'

const pageHeadHeight = 73;
const appBarHeight = 48;

const styles = (t: Theme) => createStyles({
  root: {
    paddingTop: t.spacing.unit * 3,
    paddingBottom: t.spacing.unit * 2,
    minHeight: `calc(100vh - 48px)`,
    [t.breakpoints.down('xs')]: {
      paddingLeft: t.spacing.unit * 2,
      paddingRight: t.spacing.unit * 2
    },
  },
  rootWithHeader: {
    paddingTop: t.spacing.unit * 3,
    paddingBottom: t.spacing.unit * 2,
    minHeight: `calc(100vh - ${appBarHeight}px - ${pageHeadHeight}px - ${t.spacing.unit * 3}px - ${t.spacing.unit * 2}px )`
  }
});

interface IProps extends WithStyles<typeof styles> {
  animated?: boolean
  width?: any;
  withHead?: boolean;
}

class Page extends React.Component<IProps, any> {

  static defaultProps = {
    animated: true
  };

  render() {
    const {classes, width, children, animated, withHead} = this.props;
    return (
      <RcPage animated={animated} className={withHead ? classes.rootWithHeader : classes.root} width={width || css.pageWidth}>
        {children}
      </RcPage>
    );
  }
}

export default withStyles(styles)(Page);



// WEBPACK FOOTER //
// ./src/shared/Page/Page.tsx